import React from "react";
import { useTranslation } from "react-i18next";
import { TextField, Box } from "@mui/material";
import GenericButton from "../Custom/GenericButton";

const CustomFilter = ({ searchText, setSearchText, handleFilterClick }) => {
  const { t } = useTranslation();
  return (
    <>
      <TextField
        type="text"
        value={searchText}
        onChange={(e) => setSearchText(e.target.value)}
        placeholder="Search Farmers"
        fullWidth
        sx={{
          marginTop: "10px",
          marginBottom: "10px",
        }}
      />
      <Box sx={{ width: "100%", mb: 1 }}>
        <GenericButton
          onClick={handleFilterClick}
          backgroundColor="primary"
          fontColor="#fff"
          fontSize="14px"
          padding="7px 10px"
          style={{ width: "100%" }}
        >
          {t("Search")}
        </GenericButton>
      </Box>
    </>
  );
};

export default CustomFilter;
